// Copyright ©️ 2026 eVolve MEP, LLC

import type { HexTriplet } from '@evolvemep/api-ts';
import { Flex, TextInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';

import { WrappedColorPicker } from 'components/Mantine/ColorPickers/WrappedColorPicker';

type ColorAndNameFormValues = { color: HexTriplet; name: string };

type Props<T extends ColorAndNameFormValues> = {
  form: UseFormReturnType<T>;
  maxNameLength?: number;
  placeholder?: string;
};

export const ColorAndNameFields = <T extends ColorAndNameFormValues>({
  form,
  maxNameLength,
  placeholder,
}: Props<T>) => (
  <Flex align="center" gap="xs" flex={1}>
    <WrappedColorPicker
      value={form.getInputProps('color').value}
      disabled={form.submitting}
      {...form.getInputProps('color')}
    />
    <TextInput
      size="xs"
      autoFocus
      data-autofocus
      flex={1}
      maxLength={maxNameLength}
      disabled={form.submitting}
      placeholder={placeholder}
      {...form.getInputProps('name')}
    />
  </Flex>
);
